/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  console.log("currentUser",currentUser)
  return {
    canAdmin: currentUser && currentUser.role === 'admin',
    canCandidate: currentUser && currentUser.role === 'candidate',
    canCompany: currentUser && currentUser.role === 'company',
  };
}
